import React, {useEffect, useState} from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ButtonAction from '../../../_common/components/ButtonAction';
import {useOrderDetailsUIFilesContext} from '../OrderDetailsUIFilesContext';
import ButtonUpdateFileType from '../ButtonUpdateFileType';
import ButtonEditFileName from '../ButtonEditFileName';
import ButtonViewFile from '../../../_common/components/ButtonViewFile';
import Thumbnail from '../../../_common/components/Thumbnail';
import PopupEditDocSyncFusion from '../../../_common/components/PopupEditDocSyncFusion';
import PopupDeleteFile from '../../../_common/components/PopupDeleteFile/PopupDeleteFile';
import {getFilePreview} from '../../_redux/actions/OrderFilesActions';
import FileIcon from '../../../_common/components/FileIcon';
import ButtonDD from "../../../_common/components/ButtonDD";
import styles from '../styles.module.scss';

interface FileItemProps {
  orderID: number,
  fileID: number,
  fileName: string,
  fileExtension: string,
  uploadTime: string,
  orderFileTypeID: number,
  fileTypeID: number,
  fileTypeName: string,
  folderID: number,
  uploadedByUserID: number,
  uploadedByUserFirstName: string,
  uploadedByUserLastName: string,
  link: string,
  thumbnail?: string,
}

export function FileItem({
                           orderID,
                           fileID,
                           uploadTime,
                           fileName,
                           fileExtension,
                           fileTypeID,
                           fileTypeName,
                           uploadedByUserFirstName,
                           uploadedByUserLastName,
                           thumbnail
                         }: FileItemProps) {
  const {
    handleDownloadFile,
    handleDeleteFile,
    handleViewFile,
    updateEditedFile,
    updateFileList
  } = useOrderDetailsUIFilesContext();
  const isOfficeDocument = fileExtension === 'doc' || fileExtension === 'docx';
  const handleFileUpdate = (file: Blob) => updateEditedFile(fileID, file);

  const [data, setData] = useState('');

  useEffect(() => {
    if (isOfficeDocument) {
      getFilePreview({orderID, fileName})
        .then(result => {
          setData(result || '');
        });
    }
  }, [orderID, fileID]);

  return (
    <div key={fileID} className={styles.row}>
      <Thumbnail fileExtension={fileExtension} uri={thumbnail} fileToSave={null}/>
      <div className={classnames(styles.cell, 'badge', 'text-dark-75 font-weight-bolder font-size-lg text-nowrap')}>
        <div className={styles.dateCell}>
          {uploadTime ? moment(uploadTime).format('DD-MM-YYYY') : ''}
        </div>
      </div>
      <div className={styles.cell}>
        {[uploadedByUserFirstName, uploadedByUserLastName].filter(Boolean).join(' ')}
      </div>
      <div className={classnames(styles.cell, 'd-flex align-items-center')}>
        <ButtonEditFileName fileID={fileID} fileName={fileName}/>
        <div className="ml-2 text-truncate" title={fileName}>{fileName}</div>
      </div>
      <div className={styles.cell}>
        <FileIcon fileExtension={fileExtension} size={'sm'}/>
      </div>
      <div className={classnames(styles.cell, 'd-flex align-items-center')}>
        <ButtonUpdateFileType fileID={fileID} fileTypeID={fileTypeID}/>
        <div className="ml-2 text-truncate" title={fileTypeName}>{fileTypeName || '...'}</div>
      </div>
      <div className={styles.lastCell}>
        <ButtonDD
          menuPosition={'right'}
          label={null}
          items={[{
            itemContent: (
              <div className="d-flex justify-content-between align-items-center">
                {!isOfficeDocument && (
                  <ButtonViewFile
                    fileExtension={fileExtension}
                    onClick={() => handleViewFile(fileName)}
                  />
                )}
                {isOfficeDocument && data && (
                  <PopupEditDocSyncFusion
                    docName={fileName}
                    file={data}
                    onSave={handleFileUpdate}
                    updateFileList={updateFileList}
                  />
                )}
                <div className={'mx-2'}/>
                <PopupDeleteFile
                  fileName={fileName}
                  onDelete={() => {
                    handleDeleteFile(fileID, fileName);
                  }}
                />
                <div className={'mx-2'}/>
                <ButtonAction
                  iconButtonType={'secondary'}
                  variant={'icon'}
                  label={
                    <img
                      src={'../../../media/common/Download_secondary.svg'}
                      alt="download" className="w-20px h-20px"
                    />
                  }
                  onClick={() => handleDownloadFile(fileName)}
                  disabled={false}
                />
              </div>
            )
          }
          ]}
        />
      </div>
    </div>
  );
}